<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-center">
          <div>
            <h2 class="mb-4">Move Coach Clients</h2>

            <v-alert v-if="success" type="success" dismissible>Clients have been moved</v-alert>

            <v-select
              v-model="formData.fromCoach"
              item-text="email"
              item-value="id"
              :items="users"
              label="From"
            ></v-select>

            <div v-if="oneOnOneSubscriptions" class="mt-n4">
              <v-checkbox
                v-model="formData.moveOneOnOne"
                :label="`Move One-on-one clients (${oneOnOneSubscriptions.length})`"
              />
            </div>
            <div v-if="clubSubscriptions" class="mt-n4">
              <v-checkbox v-model="formData.moveClub" :label="`Move club clients (${clubSubscriptions.length})`" />
            </div>
            <v-select v-model="formData.toCoach" item-text="email" item-value="id" :items="users" label="To" />

            <v-textarea label="Chat Welcome Message" v-model="formData.chatText" rows="4" auto-grow />
            <p class="caption mt-n2">Mail merge variables: #firstname#</p>
            <v-file-input v-model="formData.chatAttachment" label="Chat Welcome Video" show-size />

            <v-btn color="secondary" :loading="saving" rounded @click="save()" :disabled="!buttonEnabled"
              >Move Clients</v-btn
            >
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { STAFF_QUERY } from "@/constants/graphql/users/user";
import { SIMPLE_COACHING_SUBSCRIPTION_QUERY, MOVE_COACH_CLIENTS_MUTATION } from "@/constants/graphql/coach/coaching";
import { extractNodes } from "@/lib/array";

export default {
  name: "MoveCoachClients",
  data() {
    return {
      saving: false,
      success: false,
      oneOnOneSubscriptions: null,
      clubSubscriptions: null,
      formData: this.resetFormData(),
    };
  },
  computed: {
    buttonEnabled() {
      return this.formData.fromCoach && this.formData.toCoach && (this.formData.moveOneOnOne || this.formData.moveClub);
    },
  },
  methods: {
    resetFormData() {
      return {
        fromCoach: null,
        toCoach: null,
        moveOneOnOne: false,
        moveClub: false,
        chatText: null,
        chatAttachment: null,
      };
    },
    async save() {
      this.saving = true;
      const result = await this.$apollo.mutate({
        mutation: MOVE_COACH_CLIENTS_MUTATION,
        variables: {
          data: this.formData,
        },
      });
      this.saving = false;
      this.success = result.data?.moveCoachClientsMutation?.success;
      this.formData = this.resetFormData();
    },
  },
  apollo: {
    oneOnOneSubscriptions: {
      query: SIMPLE_COACHING_SUBSCRIPTION_QUERY,
      variables() {
        return {
          coachId: this.formData.fromCoach,
          productType: "one-on-one",
          active: true,
        };
      },
      skip() {
        return !this.formData.fromCoach;
      },
      update(data) {
        return extractNodes(data.userSubscriptions.edges);
      },
    },
    clubSubscriptions: {
      query: SIMPLE_COACHING_SUBSCRIPTION_QUERY,
      variables() {
        return {
          coachId: this.formData.fromCoach,
          productType: "club",
          active: true,
        };
      },
      skip() {
        return !this.formData.fromCoach;
      },
      update(data) {
        return extractNodes(data.userSubscriptions.edges);
      },
    },
    users: {
      query: STAFF_QUERY,
      variables() {
        return {
          isActive: true,
          isStaff: true,
        };
      },
      update(data) {
        return extractNodes(data.users.edges);
      },
    },
  },
};
</script>
